module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.912ec66d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 977
// module chunks = 7